import { SearchspringFetcher } from '../classes/searchspring-fetcher'

import { generateSearchspringProvider } from './provider'
import { normaliseResults } from '../helpers/normalisers'

export class SearchspringAutocomplete extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/search/autocomplete.json'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { query, originalQuery, resultsPerPage } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')

    this.params.set('q', query)
    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)
    if (originalQuery) this.params.set('oq', originalQuery)

    super.updateParams()
  }
}

export const SearchspringAutocompleteProvider = generateSearchspringProvider(SearchspringAutocomplete, (results) => {
  return {
    ...results,
    results: normaliseResults(results.results)
  }
})
